import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../core/layout/components/abstracts/base.component';
import { ContentBoxComponent } from '../content-box/content-box.component';
import { FormsModule } from '@angular/forms';
import { MinWidthDirective } from '../../directives/min-width.directive';
import { MaxWidthDirective } from '../../directives/max-width.directive';

@Component({
  selector: 'app-content-editable-input',
  standalone: true,
  imports: [
    ContentBoxComponent,
    FormsModule,
    MinWidthDirective,
    MaxWidthDirective,
  ],
  templateUrl: './content-editable-input.component.html',
  styleUrl: './content-editable-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentEditableInputComponent extends BaseComponent {

  @Input() set value(val: string) {
    this._rawValue = val;
    this.updateFormattedValue();
    this.cdr.detectChanges();
  };

  @Input() inputType: 'currency' | 'percentage' = 'currency';
  @Output() valueChange = new EventEmitter<string>();

  private _rawValue = '';
  private _value = '0,00';

  public get value(): string {
    return this._value;
  }

  public onKeyDown(event: KeyboardEvent): void {
    if (event.key >= '0' && event.key <= '9') {
      this._rawValue += event.key;
    } else if (event.key === 'Backspace') {
      this._rawValue = this._rawValue.slice(0, -1);
    }

    this.updateFormattedValue();
    event.preventDefault();
    this.valueChange.emit(this._rawValue);
  }

  private updateFormattedValue(): void {
      this._value = (Number(this._rawValue) / 100).toCurrency();
    }
  }
